// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"Carousel_carouselWrapper__UlqDX","fadeOut":"Carousel_fadeOut__SJ1wb"};